import { Controller } from '@hotwired/stimulus'
import { isPasswordValid } from '../utils'

// Connects to data-controller="password"
export default class extends Controller {
  static targets = ['input', 'error', 'length']
  static values = {
    minLength: { type: Number },
  }
  static classes = ['hidden', 'error', 'valid', 'invalid']

  connect() {
    this.#validateIfHasError()
  }

  toggleReveal(_event) {
    const reveal = this.inputTarget.type === 'password'
    this.inputTarget.type = reveal ? 'text' : 'password'
    // Pilote l'icône œil/œil barré (variantes CSS [[data-password-revealed]_&]).
    this.element.toggleAttribute('data-password-revealed', reveal)
  }

  validate(_event) {
    const isValid = isPasswordValid(this.inputTarget.value, { minLength: this.minLengthValue })

    if (isValid) {
      this.lengthTarget.classList.add(this.validClass)
      this.lengthTarget.classList.remove(this.invalidClass)
    } else {
      this.lengthTarget.classList.remove(this.validClass)
      this.lengthTarget.classList.add(this.invalidClass)
    }

    this.errorTarget.classList.remove(this.hiddenClass)

    return isValid
  }

  #validateIfHasError() {
    if (!this.hasErrorClass) return

    if (this.element.querySelector('.' + this.errorClass)) this.validate()
  }
}
